import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { signUp, updateUser } from '../../../../../Redux/auth/authSlice'
import SignatureCanvas from 'react-signature-canvas'
import { useTranslation } from 'react-i18next'

const predefinedColors = [
  '#FF6B6B', // Coral Red
  '#4ECDC4', // Turquoise
  '#45B7D1', // Sky Blue
  '#96CEB4', // Sage Green
  '#FFEEAD', // Cream Yellow
  '#D4A5A5', // Dusty Rose
  '#9B59B6', // Purple
  '#3498DB', // Blue
  '#2ECC71', // Emerald
  '#F1C40F', // Yellow
  '#E67E22', // Orange
  '#E74C3C', // Red
  '#1ABC9C', // Teal
  '#34495E', // Dark Blue
  '#7F8C8D', // Gray
  '#000000'  // Black
]

const index = ({ close, userdata }) => {
  const { t } = useTranslation() || ((text) => text)
  const [selectedColor, setSelectedColor] = useState(userdata?.color || '#000000')
  const [selectedRole, setSelectedRole] = useState(userdata?.role || 'standard')
  const [signatureType, setSignatureType] = useState('canvas') // 'canvas' or 'image'
  const [signatureImage, setSignatureImage] = useState(null)
  const [signatureImagePreview, setSignatureImagePreview] = useState('')

  const { id, phone, email, dob, displayName, signature, ...rest } = userdata || {
    id: null,
    nid: '',
    phone: '',
    photoURL: '',
    email: '',
    dob: '',
    displayName: '',
    signature: ''
  }
  const dispatch = useDispatch()

  const canvasRef = useRef(null)
  const fileInputRef = useRef(null)

  const handleImageUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Ju lutem zgjidhni një imazh të vlefshëm')
        return
      }
      
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Madhësia e imazhit duhet të jetë më e vogël se 5MB')
        return
      }

      setSignatureImage(file)
      
      // Create preview
      const reader = new FileReader()
      reader.onload = (e) => {
        setSignatureImagePreview(e.target.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const clearSignatureImage = () => {
    setSignatureImage(null)
    setSignatureImagePreview('')
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const submitData = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    
    let signatureData = ''
    
    if (signatureType === 'canvas') {
      signatureData = canvasRef?.current?.isEmpty() ? '' : canvasRef?.current?.toDataURL()
    } else if (signatureType === 'image' && signatureImage) {
      // Convert image to base64
      const reader = new FileReader()
      reader.onload = (e) => {
        const formObject = {
          email: formData.get('email'),
          password: formData.get('password'),
          displayName: formData.get('full_name'),
          phone: formData.get('phone'),
          nid: formData.get('nid') || '',
          dob: formData.get('dob'),
          signature: e.target.result,
          color: selectedColor,
          role: selectedRole,
          close
        }
        
        if (!userdata) {
          dispatch(signUp(formObject))
        } else {
          dispatch(
            updateUser({
              ...rest,
              ...formObject,
              id
            })
          )
        }
      }
      reader.readAsDataURL(signatureImage)
      return
    } else if (signatureType === 'image' && signatureImagePreview && !signatureImage) {
      // Use existing image preview (for editing)
      signatureData = signatureImagePreview
    }
    
    // If no signature is provided, use empty string
    if (!signatureData) {
      signatureData = ''
    }
    
    const formObject = {
      email: formData.get('email'),
      password: formData.get('password'),
      displayName: formData.get('full_name'),
      phone: formData.get('phone'),
      nid: formData.get('nid') || '',
      dob: formData.get('dob'),
      signature: signatureData,
      color: selectedColor,
      role: selectedRole,
      close
    }
    
    if (!userdata) {
      dispatch(signUp(formObject))
    } else {
      dispatch(
        updateUser({
          ...rest,
          ...formObject,
          id
        })
      )
    }
  }

  useEffect(() => {
    if (userdata && signature) {
      // Check if signature is a data URL (canvas) or image URL
      if (signature.startsWith('data:image/')) {
        // Try to determine if it's a canvas signature or uploaded image
        // For now, we'll assume it's a canvas signature
        try {
          canvasRef?.current?.fromDataURL(signature)
          setSignatureType('canvas')
        } catch (error) {
          console.error('Error loading canvas signature:', error)
          // If canvas loading fails, treat as image
          setSignatureImagePreview(signature)
          setSignatureType('image')
        }
      } else if (signature) {
        // It might be an image URL or other format
        setSignatureImagePreview(signature)
        setSignatureType('image')
      }
    } else if (userdata && !signature) {
      // User exists but has no signature
      setSignatureType('canvas')
      setSignatureImagePreview('')
    }
  }, [userdata, signature])

  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.form_header}>
        <h2 className={styles.header_text}>{userdata ? t('EDIT_EMPLOYEE') : t('ADD_NEW_EMPLOYEE')}</h2>
        <button className={styles.close_btn} onClick={close}>
          ✖
        </button>
      </div>
      <form className={styles.popup_from_container} onSubmit={submitData}>
        {!userdata && (
          <>
            <div className={styles.form_entry}>
              <label className={styles.entry_label} htmlFor='email'>
                {t('email')}
              </label>
              <input defaultValue={email} className={styles.entry_input} required type='email' id='email' name='email' />
            </div>
            <div className={styles.form_entry}>
              <label className={styles.entry_label} htmlFor='password'>
                {t('password')}
              </label>
              <input defaultValue={email} className={styles.entry_input} required type='password' id='password' name='password' />
            </div>
          </>
        )}
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='full_name'>
            {t('full_name')}
          </label>
          <input defaultValue={displayName} className={styles.entry_input} required type='text' id='full_name' name='full_name' />
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='phone'>
            {t('phone')}
          </label>
          <input defaultValue={phone} className={styles.entry_input} required type='text' id='phone' name='phone' />
        </div>
        {/* <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='nid'>
            National ID
          </label>
          <input defaultValue={nid} className={styles.entry_input} type='text' id='nid' name='nid' />
        </div> */}
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='dob'>
            {t('date_of_birth')}
          </label>
          <input defaultValue={dob} className={styles.entry_input} type='date' id='dob' name='dob' />
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label}>
            {t('color')}
          </label>
          <div className={styles.color_picker_container}>
            <div className={styles.color_grid}>
              {predefinedColors.map((color) => (
                <button
                  key={color}
                  type="button"
                  className={`${styles.color_option} ${selectedColor === color ? styles.selected : ''}`}
                  style={{ backgroundColor: color }}
                  onClick={() => setSelectedColor(color)}
                />
              ))}
            </div>
            <div className={styles.selected_color_preview}>
              <div 
                className={styles.color_preview} 
                style={{ backgroundColor: selectedColor }}
              />
              <span className={styles.color_value}>{selectedColor}</span>
            </div>
          </div>
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='role'>
            {t('role')}
          </label>
          <select
            id='role'
            name='role'
            className={styles.entry_input}
            value={selectedRole}
            onChange={e => setSelectedRole(e.target.value)}
            required
          >
            <option value='standard'>{t('standard')}</option>
            <option value='admin'>{t('admin')}</option>
          </select>
        </div>
        
        {/* Signature Section */}
        <div className={styles.form_entry}>
          <label className={styles.entry_label}>
            {t('signature')}
          </label>
          
          {/* Signature Type Toggle */}
          <div className={styles.signature_type_toggle}>
            <button
              type="button"
              className={`${styles.toggle_btn} ${signatureType === 'canvas' ? styles.active : ''}`}
              onClick={() => setSignatureType('canvas')}
            >
              {t('draw_signature') || 'Vizato nënshkrimin'}
            </button>
            <button
              type="button"
              className={`${styles.toggle_btn} ${signatureType === 'image' ? styles.active : ''}`}
              onClick={() => setSignatureType('image')}
            >
              {t('upload_image') || 'Ngarko imazh'}
            </button>
          </div>
          
          {/* Canvas Signature */}
          {signatureType === 'canvas' && (
            <div className={styles.canvas_signature_container}>
              <SignatureCanvas
                canvasProps={{
                  className: styles.signiture_canvas,
                  id: 'signiture_canvas'
                }}
                ref={canvasRef}
                clearOnResize={false}
              />
              <button className={styles.clear_signiture} onClick={() => canvasRef?.current?.clear()} type='button'>
                {t('clear')}
              </button>
            </div>
          )}
          
          {/* Image Upload Signature */}
          {signatureType === 'image' && (
            <div className={styles.image_signature_container}>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className={styles.file_input}
                id="signature_image"
              />
              <label htmlFor="signature_image" className={styles.file_input_label}>
                {signatureImagePreview ? t('change_image') || 'Ndrysho imazhin' : t('select_image') || 'Zgjidh imazh'}
              </label>
              
              {signatureImagePreview && (
                <div className={styles.image_preview_container}>
                  <img 
                    src={signatureImagePreview} 
                    alt="Signature Preview" 
                    className={styles.signature_image_preview}
                  />
                  <button 
                    type="button" 
                    className={styles.clear_image_btn}
                    onClick={clearSignatureImage}
                  >
                    {t('remove_image') || 'Hiq imazhin'}
                  </button>
                </div>
              )}
              
              {!signatureImagePreview && (
                <div className={styles.no_signature_message}>
                  <p>{t('no_signature_selected') || 'Nuk ka nënshkrim të zgjedhur'}</p>
                  <small>{t('signature_optional') || 'Nënshkrimi është opsional'}</small>
                </div>
              )}
            </div>
          )}
        </div>
        
        <div className={styles.form_entry}>
          <button className={styles.submit_button} type='submit'>
            {userdata ? t('save') : t('add')}
          </button>
        </div>
      </form>
    </div>
  )
}
export default index
